import React, { ReactNode, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

type InfoTooltipProps = {
    message: string;
    title?: string;
    direction?: 'top' | 'bottom' | 'left' | 'right';
    children?: ReactNode;
    infoIconVerticalAlignment?: 'top' | 'center' | 'bottom';
};

const InfoTooltip = ({
    message,
    title,
    direction = 'top',
    children,
    infoIconVerticalAlignment = 'center',
}: InfoTooltipProps): JSX.Element => {
    const [tooltipVisible, setTooltipVisible] = useState<boolean>(false);

    return (
        <div
            className={`component-info-tooltip${!!children ? ' with-children' : ''}${infoIconVerticalAlignment ? ` info-icon-align-${infoIconVerticalAlignment}` : ''}`}
        >
            {children}
            <div className="info-icon-container">
                <FontAwesomeIcon
                    icon={faCircleInfo}
                    className="info-icon"
                    onMouseEnter={(): void => setTooltipVisible(true)}
                    onMouseLeave={(): void => setTooltipVisible(false)}
                />
                <div
                    className={`info-tooltip-container${tooltipVisible ? ' visible' : ''}${direction ? ` ${direction}` : ''}`}
                >
                    {title ? <h3>{title}</h3> : null}
                    <p>{message}</p>
                </div>
            </div>
        </div>
    );
};

export default InfoTooltip;
